export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-background-100 via-background-50 to-background-100" />
        <div className="absolute inset-0 bg-[radial-gradient(60%_50%_at_50%_0%,oklch(var(--primary-100)/0.55),transparent)]" />
      </div>

      <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center px-4 pt-[84px] pb-[24px] text-center md:px-6 md:pt-[204px] md:pb-[48px]">
        <h1 className="w-full text-center font-heading text-4xl font-black leading-tight text-foreground-950 md:text-7xl">
          <span className="block">人と企業の可能性を</span>
          <span className="mt-[5px] block">テクノロジーでひらく</span>
        </h1>

        <p className="mt-5 max-w-2xl font-body text-sm leading-relaxed text-foreground-700 md:mt-8 md:text-lg">
          採用・人材活用・組織づくりを
          <br className="hidden md:block" />
          新しいテクノロジーと営業支援でサポートします
        </p>

        <div className="mt-6 flex w-full flex-col items-center justify-center gap-3 sm:w-auto sm:flex-row md:mt-10">
          <a
            href="#contact"
            className="flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-8 py-4 font-label text-sm font-bold text-white transition-colors hover:bg-primary-600 sm:w-auto whitespace-nowrap"
          >
            資料請求する
            <i className="ri-file-list-3-line" />
          </a>
        </div>
      </div>
    </section>
  );
}